import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuBarComponent } from './menu-bar.component';
import { NumberModule } from '../number/number.module';
import { WinningPlanComponent } from './winning-plan/winning-plan.component';
import { DrawingHistoryComponent } from './drawing-history/drawing-history.component';
import { TicketHistoryComponent } from './ticket-history/ticket-history.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    NumberModule,
    FormsModule,
    SharedModule
  ],
  declarations: [MenuBarComponent, WinningPlanComponent, DrawingHistoryComponent, TicketHistoryComponent],
  exports: [MenuBarComponent]
})
export class MenuBarModule {
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/menu-bar/menu-bar.module.ts